import React from 'react'
import _, { forEach } from 'lodash'
import moment from 'moment'
import { connect } from 'react-redux'
import { ROUTES } from '../navigation/route-constants'
import Trailer from './Trailer'
import VersionSelector from './VersionSelector'
import ShowtimeSchedule from '../showtime/ShowtimeSchedule'
import MovieInfo from './MovieInfo'
import Pictures from './Pictures'
import Poster from './Poster'
import ShowtimeSchedulev2 from '../showtime/ShowtimeSchedulev2'
import {  selectedMovieChanged } from '../../actions/movielist-actions'


export default class Movie extends React.Component {

   


    createLabels(movieObj) {
        const { movie, showtimeTypes, } = this.props
        let the_movie = movie.versions.length === 0 ? movie : movieObj
        let shows = []
        

        if (the_movie.showtimesByOrgId  ) {
            _.forOwn(the_movie.showtimesByOrgId, (showtimes, orgId) => {
              
                let tt = showtimes.map((i) => i.type !== null ? i.type : '')
             
              
              
                   function groupBy( tt, property) {
                    return tt.reduce(function (memo, x) {
                        if (!memo[x[property]]) {
                            memo[x[property]] = [];
                        }
                        memo[x[property]].push(x);
                        return memo;
                    }, {});
                }

                //group by name
                const grouped = tt && groupBy(tt, "name");
                const keys = Object.keys(grouped);
                var output = [];

                //loop keys
                keys.forEach(key => {
                    //merge using reduce
                    const out = grouped[key].reduce((acc, current) => {
                        return {
                            id: current.id,
                            name: current.name,
                            
                        }
                    });
                    output.push(out);
                });
               
              
               
                const index = showtimeTypes ? _.findIndex(showtimeTypes, (showType) => { return output[0].id == showType.id }) : null;
                const indx = showtimeTypes ? _.findIndex(showtimeTypes, (showType) => { return output[1] && output[1].id == showType.id }) : null;
                const ind = showtimeTypes ? _.findIndex(showtimeTypes, (showType) => { return output[2] && output[2].id == showType.id }) : null;
                const idx = showtimeTypes ? _.findIndex(showtimeTypes, (showType) => { return output[3] && output[3].id == showType.id }) : null;
                const inx = showtimeTypes ? _.findIndex(showtimeTypes, (showType) => { return output[4] && output[4].id == showType.id }) : null;

               // console.log(index, indx,ind,idx,inx)
                shows.push(<div className="labelsContainer" key={tt.id} style={{
                    //marginLeft: window.location.pathname.includes('/film-infov2') ? '40%' : '20%',
                    color: window.location.pathname.includes('/film-infov2') ? 'white': ''
                }}>
                    {index !== -1 &&
                        <span className="ShowtimeType">
                            <span className="showtime-type-icon"> {index > -1 ? index + 1 : ''} </span>  {output[0].name}   </span>}

                    {indx !== -1 &&
                        <span className="ShowtimeType">
                            <span className="showtime-type-icon" > {indx > -1 ? indx + 1 : ''} </span> {output[1] && output[1].name}</span>   }

                    {ind !== -1 &&
                        <span className="ShowtimeType" >
                            <span className="showtime-type-icon"> {ind > -1 ? ind + 1 : ''} </span>  {output[2] && output[2].name} </span>
                    }

                    { idx !== -1 &&
                        <span className="ShowtimeType" >  <span className="showtime-type-icon"> {idx > -1 ? idx + 1 : ''} </span>{output[3] && output[3].name}
                            </span>}

                    {inx !== -1 &&
                        <span className="ShowtimeType" >
                            <span className="showtime-type-icon"> {inx > -1 ? inx + 1 : ''} </span>

                            {output[4] && output[4].name}
                            </span>}
                     
                </div>)
            })

        }
        return shows
      
    }

    generateShowtimeSchedulesNoVersion() {
        const { movie, appLocale, organizers, showExpired, filterIds, columns, showLocationOnShowtime, showtimeClicked } = this.props;

        let showtimeSchedules = [];
       

        if (movie.showtimesByOrgId) {

            _.forOwn(movie.showtimesByOrgId, (showtimes, orgId) => {
                if (showtimes.length > 0) {
                    const isMultiBio = organizers.length > 1;

                    const orgName = _.find(organizers, (org) => { return org.id == orgId });

                    showtimeSchedules.push(
                        <div key={orgId} className="organizer">
                            {isMultiBio && orgName ? <h3>{orgName.name}</h3> : null}

                            <ShowtimeSchedulev2 movie={{ ...movie, validShowtimes: showtimes }}
                                showtimeClicked={showtimeClicked}
                                appLocale={appLocale}
                                showExpired={showExpired}
                                filterIds={filterIds}
                                showLocationOnShowtime={showLocationOnShowtime}
                                columns={columns}
                                output={this.output} />

                        </div>);
                }
            });
        }



        return showtimeSchedules;


    }

    generateShowtimeSchedules(movieObj) {
        const { appLocale, organizers, showExpired, filterIds, movies, output, brand, all_showtimes, organizerIds, showtimeClicked, columns, showLocationOnShowtime } = this.props;
     
        let showtimeSchedules = [];
        if (!movieObj.showtimesByOrgId) {
            movieObj.showtimesByOrgId = { organizers : all_showtimes.filter((shows) => { return shows.movieId === movieObj.id }) }
        
        }
       

        if (movieObj.showtimesByOrgId)  {

            _.forOwn(movieObj.showtimesByOrgId, (showtimes, orgId) => {
                if (showtimes.length > 0) {
                    const isMultiBio = organizers.length > 1;
                  
                    const orgName = _.find(organizers, (org) => { return org.id == orgId });

                    showtimeSchedules.push(
                        <div key={orgId} className="organizer">
                            {isMultiBio && orgName ? <h3>{orgName.name}</h3> : null}
                           
                            <ShowtimeSchedulev2 movie={{ ...movieObj, validShowtimes: showtimes }}
                                showtimeClicked={showtimeClicked}
                                appLocale={appLocale}
                                showExpired={showExpired}
                                filterIds={filterIds}
                                showLocationOnShowtime={showLocationOnShowtime}
                                columns={columns}
                               
                                output={this.output} />
                         
                        </div>);
                        }
            });
        }
      

       
        return showtimeSchedules;
           
       
    }

    movieClicked(e) {
        e.preventDefault();
        const movieId = e.currentTarget.id;
        this.props.movieClicked(movieId);
        // window.location.reload()
    }

   

    render() {
      
        const { movie, movieClicked, appLocale, iframeId, movies, actions, organizerIds,  } = this.props;
        const version2 = _.find(movie.versions, (version) => {
            if (version.id !== movie.id)
                return version.id
        })
      
        const trailer = movie.trailer ? <Trailer trailerUrl={movie.trailer} trailerPoster={movie.trailerPoster} iframeId={iframeId} /> : null;
       
        const poster = movie.posters ? <Poster movie={movie} /> : null;
        const pictures = movie.pictures ? <Pictures pictureUrls={movie.pictures} /> : null;
        const movieNameLocale = movie.names ? (movie.names[appLocale] ? movie.names[appLocale] : movie.names['da']) : movie.name;
      

        const allVersions = _.map(movie.versions, (version, i) => {
           
            return <>
                {
                    version.id === movie.id &&
                    <div className='versioncont' style={{ display: 'flex', flexDirection: 'column' }}>
                        {version.id === movie.id && movie.versions.length > 1 &&
                            <p className='version'>{version.name}</p>
                        }
                        {version.id === movie.id &&
                            <div className="schedules">{this.generateShowtimeSchedules(movie)}</div>
                        }
                        {version.id === movie.id &&
                            <div style={{ marginBottom: '10px' }}>   {this.createLabels(movie)} </div>
                        }
                        <hr style={{ width: '100 %', opacity: '0.1', margin: '20px 0px  40px ' }} ></hr>

                    </div>
                }
                        

                {  movie.versions.length > 1 ?
                      
                            version.id !== movie.id &&
                    <div className='versioncont' style={{   display: 'flex', flexDirection: 'column'  }}> 
                               

                                <p className='version'>{version.name}</p>
                            <div className="schedules">{this.generateShowtimeSchedules(version2)}</div>
                            <div style={{ marginBottom: '10px' }}>   {this.createLabels(version2)} </div>
                            <hr style={{ width: '100 %', opacity: '0.1', margin: '20px 0px  40px ' }} ></hr>

                     </div> 
                            
                       : ''}
              
            </>
        }) 
       
        return (
            <div className="Movie" >
                {trailer}

                { allVersions} 
                {movie.versions.length === 0 && <div className="schedules">{this.generateShowtimeSchedulesNoVersion()}</div>}
                {movie.versions.length === 0 && <div style={{ marginBottom: '10px' }}>   {this.createLabels(movie)} </div>}
                <div className="info-container" >
                    {movie.versions.length === 0 && this.generateShowtimeSchedules(movie).length ?   <hr style={{ width: '100 %', opacity: '0.1', margin: '20px 0px  40px ' }} ></hr> : null}
                    <h1>{movieNameLocale}</h1>
                    {poster}
                    <MovieInfo appLocale={appLocale} movie={movie} />
                </div>
                {/*{pictures}*/}
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
  
    return {
        actions: bindActionCreators(Object.assign({}, { selectedMovieChanged, }), dispatch)
    }
}

connect(mapStateToProps)(Movie)